var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-gray wraper" }, [
    _c(
      "div",
      { staticClass: "panel-header compact", attrs: { id: "list-header" } },
      [
        _vm.instrumentId
          ? [
              _c(
                "div",
                [
                  _c("unit-path", {
                    attrs: { id: _vm.instrumentId, lastHasLink: true }
                  })
                ],
                1
              )
            ]
          : [
              _c("q-btn-toggle", {
                attrs: {
                  color: "white",
                  "no-caps": "",
                  dense: _vm.$route.name !== "cases",
                  "text-color": "primary",
                  "toggle-color": "primary",
                  options: [
                    { label: "Все", value: "all" },
                    { icon: "build", value: "active" },
                    { icon: "done_all", value: "completed" },
                    { icon: "hourglass_empty", value: "pending" },
                    { icon: "pan_tool", value: "canceled" }
                  ]
                },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              }),
              _vm._v(" "),
              _vm.isEngineer
                ? _c("q-checkbox", {
                    attrs: { label: "Только мои" },
                    model: {
                      value: _vm.my,
                      callback: function($$v) {
                        _vm.my = $$v
                      },
                      expression: "my"
                    }
                  })
                : _vm._e()
            ]
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "panel-group",
        class: { scroll: _vm.$route.meta.showLeft }
      },
      [
        _vm._l(_vm.visibleCases, function(item, ind) {
          return _c("case-item", {
            key: item._id,
            class: { selected: ind === _vm.activeIndex },
            attrs: { item: item, needPath: !_vm.instrumentId }
          })
        }),
        _vm._v(" "),
        _c(
          "my-scroll",
          { ref: "myscroll", attrs: { handler: _vm.getMore } },
          [_c("q-spinner-dots", { attrs: { size: 40 } })],
          1
        ),
        _vm._v(" "),
        _c(
          "q-btn",
          {
            directives: [
              {
                name: "back-to-top",
                rawName: "v-back-to-top.animate",
                value: 500,
                expression: "500",
                modifiers: { animate: true }
              }
            ],
            staticClass: "fixed-bottom-left",
            staticStyle: { margin: "0 0 15px 15px" },
            attrs: { round: "", color: "teal-5" }
          },
          [_c("q-icon", { attrs: { name: "keyboard_arrow_up" } })],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e92fd8f4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e92fd8f4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cases-list.vue
// module id = null
// module chunks = 